// Border widths for the ContentCard in pixels (px)
export const BORDER_WIDTH = 1;
export const BORDER_WIDTH_OUTLINED = 1.5;
export const BORDER_WIDTH_IMAGE = 12;
